export enum CampaignStatusEnum {
  RUNNING = 'RUNNING',
  STOPPED = 'STOPPED',
}
